import { Checkbox as BPCheckbox, CheckboxProps } from "@blueprintjs/core";
import classNames from "classnames";
import React from "react";

import styles from "./checkbox.module.css";

const Checkbox = ({ className, ...props }: CheckboxProps) => {
  return (
    <BPCheckbox className={classNames(styles.checkbox, className)} {...props} onMouseDown={(e) => e.preventDefault()} />
  );
};

export default Checkbox;
